import { type ChangeEvent, type FC, type InputHTMLAttributes, useEffect, useState } from 'react';
import { IMaskInput } from 'react-imask';

import { Select } from 'antd';
import cn from 'classnames';

import styles from './PhoneInput.module.scss';

const options = [{ label: '🇷🇺 (+7)', value: '7' }];

interface PhoneInputProps extends InputHTMLAttributes<HTMLInputElement> {
	disabledSelect?: boolean;
	noValidate?: boolean;
	sizeType?: 'large' | 'middle';
	classnames?: {
		input?: string;
		select?: string;
	};
}

export const PhoneInput: FC<PhoneInputProps> = ({
	name,
	disabledSelect,
	value: externalValue,
	onChange,
	sizeType = 'middle',
	classnames,
	...props
}) => {
	const [countryCode, setCountryCode] = useState(options[0].value);

	const preparedValue = externalValue
		? String(externalValue).replace(new RegExp(`^${countryCode}`), '')
		: '';

	const [maskedValue, setMaskedValue] = useState(preparedValue);

	useEffect(() => {
		if (preparedValue !== maskedValue) {
			setMaskedValue(preparedValue);
		}
	}, [preparedValue, maskedValue]);

	return (
		<div className={styles.phoneInputContainer}>
			<Select
				className={styles.phoneInputCountrySelect}
				options={options}
				disabled={disabledSelect}
				value={countryCode}
				size={sizeType}
				onChange={(value) => setCountryCode(value)}
			/>
			<IMaskInput
				{...props}
				value={maskedValue}
				className={cn(styles.phoneInput, classnames?.input, {
					[styles.large]: sizeType === 'large',
					[styles.middle]: sizeType === 'middle',
					[styles.placeholderColor]: maskedValue == '',
				})}
				onAccept={(value) => {
					onChange?.({
						target: { value: `${countryCode}${value}` },
					} as ChangeEvent<HTMLInputElement>);
					setMaskedValue(value);
				}}
				unmask
				lazy={false}
				mask="(000) 000-00-00"
			/>
		</div>
	);
};
